<template>
    <!-- 对话框 -->
    <el-drawer title="导出记录" :visible.sync="show" :with-header="false" :before-close="closeDialog" size="1000px">



        <div class="container">



            <template>

                <div style="margin-bottom: 20px;color:#909399">您导出的文件生成后会暂存在云平台上，三天后会自动删除，请及时下载</div>

                <div class="tableScroll">
                    <el-table :data="tableData" class="table" ref="multipleTable" header-cell-class-name="table-header">


                        <el-table-column prop="zip_name" label="文件名" min-width="120">
                        </el-table-column>

                        <el-table-column prop="city.name" label="城市" min-width="120">
                        </el-table-column>

                        <el-table-column prop="time.YmdHis" label="创建时间" min-width="120">

                            <template slot-scope="scope">
                                {{scope.row.time.YmdHis == '0'?'':scope.row.time.YmdHis}}
                            </template>
                        </el-table-column>


                        <el-table-column label="操作" min-width="100">
                            <!-- 下载按钮 -->
                            <template slot-scope="scope">
                                <el-button v-if="scope.row.loading" icon="el-icon-loading" disabled></el-button>
                                <template v-else>   
                                    <el-button v-if="scope.row.zip_name!=null" type="primary" size="mini" @click="toExport(scope.row.zip_name,scope.row.index)">下载
                                    </el-button>
                                </template> 
                            </template>


                        </el-table-column>



                    </el-table>

                    <div class="pagination">

                        <el-pagination @size-change="handleSizeChange" @current-change="pages_function"
                            :current-page="search_data_children.page" :page-sizes="[10, 20, 30, 40 ,50]"
                            :page-size="search_data_children.limit" layout="total, sizes, prev, pager, next, jumper"
                            :total="result_data_children.count">
                        </el-pagination>

                    </div>
                </div>

            </template>
            <!-- 对话框底部按钮 -->
            <div style="display: flex;justify-content: center">
                <el-button @click="closeDialog">关闭</el-button>
            </div>
        </div>
    </el-drawer>
</template>

<script>

    var _this;
    import axios from 'axios'; // AJAX封装类
    import {
        config
    } from '@/utils/config'; //配置
    export default {
        props: {
            'isShow': Boolean
        },
        watch: {

            isShow(newData, oldData) {

                _this.show = true;

                _this.getZipBusiness();

            },
        },
        data() {
            return {


                show: false,
                zipName: '',

                //存放表格数据
                tableData: [],


                //获取用户列表的数据
                search_data_children: {
                    //当前页数
                    page: 1,
                    //每页显示多少条数据
                    limit: 10

                },
                result_data_children: [],
                search_rules: {
                    page: {
                        placeholder: '页码',
                        rules: {
                            required: true,
                            message: '页码需要大于0',
                            regulation: 'gt',
                            rulesData: 0
                        }
                    },
                    limit: {
                        placeholder: '每页个数',
                        rules: {
                            required: true,
                            message: '每页个数需在1-51之内',
                            regulation: 'between',
                            rulesData: [1, 51]
                        }
                    },

                }





            };
        },
        created() {

            _this = this;


        },
        methods: {

            getZipBusiness() {

                _this
                    .$post('/business/getZipBusiness', _this.search_data_children, _this.search_rules)
                    .then((res) => {
                        // 将请求的数据存放到表格数据数组中
                        
                        for(let i=0; i<res.data.length;i++){
                            res.data[i].loading = false;
                            res.data[i].index = i;
                        }
                        

                        _this.tableData = res.data;

                        console.log(_this.tableData);

                        _this.result_data_children = res;


                    })
                    .catch((err) => { });
            },

            // 导出
            toExport(zip_name,index) {
                console.log(index);
                _this.tableData[index].loading = true;
                // return
                _this.zipName = zip_name;
                // _this.loading = true;
                _this.downZipBusiness(index);

            },
           
            downZipBusiness(index) {
                axios({
                    method: 'POST',
                    url: config.axios_baseURL + '/business/downZipBusiness',

                    data: {
                        'zipName': _this.zipName,
                    },
                    responseType: 'blob'
                }).then(response => {
                    _this.tableData[index].loading = false;

                    console.log(response,'-------');

                        const fileName = _this.zipName
                        /* 兼容ie内核，360浏览器的兼容模式 */
                        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                            const blob = new Blob([response.data], { type: 'application/zip' })
                            window.navigator.msSaveOrOpenBlob(blob, 'fileName')
                        } else {
                            /* 火狐谷歌的文件下载方式 */
                            const blob = new Blob([response.data], { type: 'application/zip' })
                            const url = window.URL.createObjectURL(blob)
                            const link = document.createElement('a') // 创建a标签
                            link.href = url
                            link.download = fileName // 文件重命名，若无需重命名，将该行删去
                            link.click()
                            URL.revokeObjectURL(url) // 释放内存
                        }
                        resolve(response)


                }).catch(error => {
                    // _this.$errorMsg(error)
                }

                )




            },




            // 关闭方法
            closeDialog() {
                _this.show = false;


            },

            //页码值改变
            pages_function(search_data) {
                //赋值
                _this.search_data_children.page = search_data;

                console.log(_this.search_data_children.page);

                //初始化列表
                _this.getZipBusiness();
            },

            //下拉条（每页显示多少数据）变化
            handleSizeChange(val) {

                console.log(val);

                _this.search_data_children.limit = val;

                _this.getZipBusiness();

            },







        }

    };
</script>

<style scoped>
    .form-box {
        padding: 20px;
        box-sizing: border-box;
        margin-right: 0;
        width: 100%;
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    .el-form-second {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
    }

    .avatar-uploader {
        width: 100px;
        height: 100px;
    }

    .tableScroll {
        max-height: 500px;
        overflow: hidden;
        overflow-y: auto;
    }
</style>